import { Colors } from '@gripp/shared-ui';
import { Image, StyleSheet, useWindowDimensions, View } from 'react-native';
import { Text } from 'react-native-paper';
import { getCurrentDimensions } from '../shared/hooks/useWindowDimensions';
import { DownloadApp } from './downloadApp';

type AnonymousReportedProps = {
  message?: { message: string; messageDownloadApp: string };
};

export const AnonymousReported = (props: AnonymousReportedProps) => {
  const dimensions = getCurrentDimensions();
  const heightStyle = { minHeight: dimensions.height };
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  return (
    <View style={[styles.container, heightStyle]}>
      <View
        style={[styles.containerBody, isMobile && styles.containerBodyMobile]}
      >
        <View>
          <Image
            style={styles.image}
            source={require('../../static-assets/GrippIconDark.png')}
            resizeMode="contain"
          />
        </View>
        <View>
          <Text style={[styles.font, styles.title]}>
            {props?.message?.message}
          </Text>
          <Text style={[styles.font, styles.downloadApp]}>
            {props.message?.messageDownloadApp}
          </Text>
        </View>
        <View style={styles.download}>
          <DownloadApp />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.black,
    width: '100%',
    height: '100%',
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'column',
    paddingHorizontal: 50,
    alignItems: 'center',
  },
  containerBody: {
    minWidth: '60%',
    maxWidth: 800,
  },
  containerBodyMobile: {
    width: '100%',
    maxWidth: '100%',
  },
  image: {
    height: 119,
    width: 121,
  },
  font: {
    color: Colors.white,
  },
  title: {
    fontSize: 38,
    fontWeight: '700',
    paddingTop: 32,
    flexWrap: 'wrap',
  },
  downloadApp: {
    paddingTop: 24,
    fontSize: 24,
    fontWeight: '500',
    lineHeight: 30,
    letterSpacing: 0,
    textAlign: 'left',
  },
  download: {
    marginTop: 67,
  },
});
